import { apiClient } from "../apiClient";

import { IXetKhoaLuanRequest } from "../../model/request/xet-khoa-luan/IXetKhoaLuanRequest";
import { IXetKhoaLuanSelectByLopRequest } from "../../model/request/xet-khoa-luan/IXetKhoaLuanSelectByLopRequest";

const XET_KHOA_LUAN_ENDPOINT = "xet-khoa-luan";
export const xetKhoaLuanApi = {
    XetKhoaLuan: (request: IXetKhoaLuanRequest) => apiClient.post(`${XET_KHOA_LUAN_ENDPOINT}`, request),
    Select: (request: IXetKhoaLuanSelectByLopRequest) => apiClient.post(`${XET_KHOA_LUAN_ENDPOINT}/select`, request),
}
